import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import {
  clans,
  PENDING,
  REV_IN_PROGRESS,
  APPROBED,
  api_v3_list_of_players_by_playerIds,
  api_v3_list_of_players_by_tournamentId,
} from "../utils/constants";

const RegistersListPage = () => {
  const { tournamentId } = useParams();

  const [regInProgress, setRegInProgress] = useState(true);
  const [regError, setRegError] = useState(false);
  const [regCompleted, setRegCompleted] = useState(false);
  const [registrations, setRegistrations] = useState([]);
  const [registrationsNum, setRegistrationsNum] = useState(0);
  const [registrationsAcceptedNum, setRegistrationsAcceptedNum] = useState(0);

  useEffect(() => {
    const fetchPlayers = async () => {
      setRegInProgress(true);
      try {
        // get players
        const { data: playersData } = await axios.get(
          api_v3_list_of_players_by_tournamentId(tournamentId)
        );

        const player_list = playersData.filter((player) =>
          [PENDING, REV_IN_PROGRESS, APPROBED].includes(player.status)
        );

        const playerIds = player_list
          .map((player) => player.playerId)
          .join(",");

        // get players detail
        const { data: playersDetails } = await axios.get(
          api_v3_list_of_players_by_playerIds(playerIds)
        );

        setRegistrations(playersDetails);
        setRegistrationsNum(playersDetails.length);
        setRegistrationsAcceptedNum(
          playersDetails.filter(
            (player) =>
              player.tournamentHistory.find(
                (th) => th.tournamentId === tournamentId
              ).status !== APPROBED
          ).length
        );
        setRegInProgress(false);
        setRegCompleted(true);
      } catch (error) {
        console.error("Error fetching players:", error);
        setRegInProgress(false);
        setRegError(true);
      }
    };

    fetchPlayers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main>
      <Wrapper className="page section section-center">
        <article>
          <h1>¿Preparados para combatir?</h1>
        </article>

        <article>
          <p>
            Los administradores iremos revisando las inscripciones pendientes.
            Podrás ver el estado de tu inscripción siempre actualizado aquí.
          </p>
          <h4>Ya somos {registrationsNum} inscritos!!</h4>
          <p>
            (este número puede variar ya que aún quedan{" "}
            {registrationsAcceptedNum} inscripciones en proceso de revisión).
          </p>
        </article>
        <article>
          <div className={`${regInProgress ? "loading" : "not-loading"}`}>
            <div className="lds-dual-ring"></div>
          </div>
          <div className={regError ? "error" : "not-error"}>
            Ha ocurrido un error cargando los inscritos
          </div>
          <div className={`register-list ${regCompleted ? "" : "not-loaded"}`}>
            {registrations.map((registration) => {
              const clan = clans.filter(
                (clan) => clan.id === registration.clanId
              );
              if (clan.length === 0) {
                clan.push({
                  id: -1,
                  name: "<No tengo clan>",
                  image: "no-clan.png",
                });
              }
              const { image, name } = clan[0];
              if (registration.reg_status !== 3) {
                return (
                  <div
                    className={`row`}
                    key={`registration-${registration.playerId}`}
                  >
                    <div className="row-content">
                      <p>
                        {image ? (
                          <img
                            className="clan-logo"
                            src={`https://alexocampos.github.io/liga-espanhola-aoe2-static/clans/${image}`}
                            alt={name}
                          />
                        ) : (
                          registration.clan
                        )}
                        <a
                          href={registration.aoe2net_principal}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {registration.username}
                        </a>
                      </p>
                      <p>
                        {registration.tournamentHistory.find(
                          (th) => th.tournamentId === tournamentId
                        ).status === PENDING ? (
                          <span className="registry reg-pend">Pendiente</span>
                        ) : (
                          ""
                        )}
                        {registration.tournamentHistory.find(
                          (th) => th.tournamentId === tournamentId
                        ).status === REV_IN_PROGRESS ? (
                          <span className="registry reg-prog">En revisión</span>
                        ) : (
                          ""
                        )}
                        {registration.tournamentHistory.find(
                          (th) => th.tournamentId === tournamentId
                        ).status === APPROBED ? (
                          <span className="registry reg-acep">Aceptado</span>
                        ) : (
                          ""
                        )}
                      </p>
                    </div>
                    <hr />
                  </div>
                );
              } else {
                return "";
              }
            })}
          </div>
        </article>
      </Wrapper>
    </main>
  );
};

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;

  .registry {
    border-radius: 4px;
    padding: 0.5rem;
  }

  .clan-logo {
    height: 40px;
    width: 40px;
  }

  .reg-pend {
    background-color: var(--clr-red-light);
  }

  .reg-acep {
    background-color: var(--clr-green-dark);
  }

  .reg-prog {
    background-color: var(--clr-orange-dark);
  }

  .row {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 3rem;
    margin-bottom: 1rem;
  }

  .row-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    margin-bottom: 0.5rem;

    p {
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        margin-right: 0.8rem;
      }
    }
  }

  hr {
    border-color: var(--clr-grey-10);
  }

  .not-loaded,
  .not-error,
  .not-loading {
    display: none;
  }

  .lds-dual-ring {
    display: inline-block;
    width: 80px;
    height: 80px;
  }
  .lds-dual-ring:after {
    content: " ";
    display: block;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid #fff;
    border-color: #fff transparent #fff transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }
  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .calendar {
    max-width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-bottom: 3rem;
    img {
      width: auto;
      height: fit-content;
      margin-right: 2rem;
      margin-top: 2rem;
    }
  }

  a {
    color: var(--clr-primary-light-4);
  }

  a:hover {
    color: var(--clr-primary-light-2);
  }

  article {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .infoBox {
    background-color: var(--clr-primary);
    padding: 2rem;
    margin-bottom: 2rem;

    a {
      color: var(--clr-black);
      font-weight: bold;
    }
  }

  ul {
    list-style-type: square;
    padding-left: 3rem;
  }

  .title {
    text-align: left;
    margin-bottom: 2rem;
  }

  .underline {
    margin-left: 0;
  }

  h1 {
    text-align: center;
    margin-bottom: 5rem;
    font-family: "True Lies", sans-serif;
    color: var(--clr-violet);
    text-shadow: -3px 0 var(--clr-grey-1), 0 3px var(--clr-grey-1),
      3px 0 var(--clr-grey-1), 0 -3px var(--clr-grey-1);
  }

  .highlightMessage {
    font-family: "True Lies", sans-serif;
    font-size: 1.5rem;
  }

  img {
    width: 100%;
  }

  .picks_explanation {
    height: 3rem;
    width: auto;
    margin-bottom: 0.8rem;
  }
`;
export default RegistersListPage;
